/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Address_1Inputs */

const en_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address *`)
};

const es_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico *`)
};

const fr_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse e-mail *`)
};

const de_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse *`)
};

const ja_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス *`)
};

const zh_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮箱地址 *`)
};

const ar_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عنوان البريد الإلكتروني *`)
};

const id_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat email *`)
};

const it_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indirizzo e-mail *`)
};

const ru_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email адрес *`)
};

const pt_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço de e-mail *`)
};

const ko_email_address_1 = /** @type {(inputs: Email_Address_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소 *`)
};

/**
* | output |
* | --- |
* | "Email address *" |
*
* @param {Email_Address_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const email_address_1 = /** @type {((inputs?: Email_Address_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Address_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_address_1(inputs)
	if (locale === "es") return es_email_address_1(inputs)
	if (locale === "fr") return fr_email_address_1(inputs)
	if (locale === "de") return de_email_address_1(inputs)
	if (locale === "ja") return ja_email_address_1(inputs)
	if (locale === "zh") return zh_email_address_1(inputs)
	if (locale === "ar") return ar_email_address_1(inputs)
	if (locale === "id") return id_email_address_1(inputs)
	if (locale === "it") return it_email_address_1(inputs)
	if (locale === "ru") return ru_email_address_1(inputs)
	if (locale === "pt") return pt_email_address_1(inputs)
	return ko_email_address_1(inputs)
});